/**
 * Configured API instances using the shared axios instance with interceptors
 * 
 * This file configures the generated OpenAPI clients to use the shared axios instance
 * that includes all interceptors for:
 * - Request ID tracking
 * - Session ID management
 * - Authentication token handling
 * - Error handling and logging
 * 
 */

import { Configuration } from './configuration';
import { DictionaryApi } from './apis/dictionary-api';
import { CanonicalTermApi } from './apis/canonical-term-api';
import { DictionaryEntryApi } from './apis/dictionary-entry-api';
import { LeadMagnetApi } from './apis/lead-magnet-api';
import { LeadApi } from './apis/lead-api';
import { AssetApi } from './apis/asset-api';
import axios, { AxiosInstance } from 'axios';
import { setupAxiosInterceptors } from '../axiosInstance';

// Create an axios instance for generated APIs with empty baseURL
// (generated API paths already include '/api')
const apiAxiosInstance: AxiosInstance = axios.create({
  baseURL: '', // Empty because generated API paths already include '/api'
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: 10000, // 10 second timeout
});

// Set up interceptors using shared utility
setupAxiosInterceptors(apiAxiosInstance);

// Create a shared configuration with the correct base path
// Note: Generated APIs already include '/api' in their paths, so we use empty basePath
const apiConfiguration = new Configuration({
  basePath: '', // Empty because generated API paths already include '/api'
  baseOptions: {
    headers: {
      'Content-Type': 'application/json',
    },
  },
});


export const dictionaryApi = new DictionaryApi(
  apiConfiguration,
  '', // Empty basePath since generated paths already include '/api'
  apiAxiosInstance // Use the axios instance without baseURL
);

export const canonicalTermApi = new CanonicalTermApi(
  apiConfiguration,
  '', // Empty basePath since generated paths already include '/api'
  apiAxiosInstance // Use the axios instance without baseURL
);

export const dictionaryEntryApi = new DictionaryEntryApi(
  apiConfiguration,
  '', // Empty basePath since generated paths already include '/api'
  apiAxiosInstance // Use the axios instance without baseURL
);

export const leadMagnetApi = new LeadMagnetApi(
  apiConfiguration,
  '', // Empty basePath since generated paths already include '/api'
  apiAxiosInstance // Use the axios instance without baseURL
);

export const leadApi = new LeadApi(
  apiConfiguration,
  '', // Empty basePath since generated paths already include '/api'
  apiAxiosInstance // Use the axios instance without baseURL
);

export const assetApi = new AssetApi(
  apiConfiguration,
  '', // Empty basePath since generated paths already include '/api'
  apiAxiosInstance // Use the axios instance without baseURL
);
